<template>
  <WsCreate
    ref="wsUpdate"
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    titleKey="name"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/app";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "",
              fields: ["name"],
            },
          ],
        },
      ],
    },
  }),
};
</script>